export default async function GetOwnerOverviewDetails() {
    let url = window.RealestateService+  `/api/OwnerOverviewDetails/GetOwnerOverviewDetails
`
    let head = {
        "content-type":"application/json",
        "accept":"*/*"
    }
    let response = await fetch(url, {
        method:"GET",
        headers:head,
    }).then(res=>res.json()).catch(res=>res)

    return response
}